import { ActionBarItem } from '../ActionBarItem';
import CallTakerModeIcon from './CallTakerModeIcon';
import CallTakerModeTooltip from './CallTakerModeTooltip';

const CallTakerModeActionBarItem = ({
  onClick,
  hasCallTakerModeAccess,
  callTakerModeSettings,
}) => {
  return (
    <ActionBarItem
      iconWidth="18px"
      onClick={onClick}
      shouldRender={hasCallTakerModeAccess}
      tooltipText={
        <CallTakerModeTooltip callTakerModeSettings={callTakerModeSettings} />
      }
      iconDataName="call-taker-mode-action-bar-item-icon"
    >
      <CallTakerModeIcon callTakerModeSettings={callTakerModeSettings} />
    </ActionBarItem>
  );
};

export default CallTakerModeActionBarItem;
